import { gql } from '@graphql/__generated__';
import { WATERMARK_SETTINGS_ANCHOR } from '@modules/_shared/components/watermark/watermarkAnchors';
import type { TourModule } from '@modules/product-updates/tours/tourTypes';

const GET_TOUR_LISTING = gql(/* GraphQL */ `
  query GetListingWatermarkTourListing($userId: uuid!) {
    own: lots(
      where: { broker_id: { _eq: $userId } }
      order_by: [{ created_at: desc }]
      limit: 1
    ) {
      id
    }
    visible: lots(order_by: [{ created_at: desc }], limit: 1) {
      id
    }
  }
`);

// The photos of a listing's Media tab (`ListingMedia.tsx`). Played from "Show
// me" on `content/releases/brochure-watermarked-photos`.
export const listingWatermarkTour: TourModule = {
  steps: t => [
    {
      anchor: WATERMARK_SETTINGS_ANCHOR,
      title: t('Watermark settings'),
      body: t(
        'Set your watermark once for this listing: its photos and its brochure then use the watermarked version.',
      ),
      placement: 'bottom-end',
    },
  ],
  // The user's latest listing, else the latest one they can see.
  resolvePath: async ({ client, userId }) => {
    const { data } = await client.query({
      query: GET_TOUR_LISTING,
      variables: { userId },
      fetchPolicy: 'network-only',
    });
    const lotId = data?.own[0]?.id ?? data?.visible[0]?.id;
    return lotId == null ? null : `/listings/${lotId}/media/images`;
  },
};
